import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-700 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading text-white">Hipobuy Spreadsheet</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              The ultimate product research database and shopping intelligence hub. Helping shoppers make smarter decisions with organized spreadsheet resources.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="/" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Home</a>
              <Link to="/hipobuy-spreadsheet-complete-guide" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Complete Guide</Link>
              <Link to="/hipobuy-spreadsheet-category-deep-dive" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Category Deep-Dive</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">Main Platform</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Comparisons</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/hipobuy-spreadsheet-vs-kakobuy" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">vs Kakobuy</Link>
              <Link to="/hipobuy-spreadsheet-vs-cssbuy" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">vs CSSBuy</Link>
              <Link to="/hipobuy-spreadsheet-vs-superbuy" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">vs Superbuy</Link>
              <Link to="/hipobuy-spreadsheet-vs-oopbuy" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">vs Oopbuy</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Top Categories</h4>
            <div className="flex flex-wrap gap-2">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Shoes</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">T-Shirts</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Hoodies</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Jackets</a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Bags</a>
              <a href="https://kaspreadsheet.com/search-923/name/Shoes.html" target="_blank" rel="noopener nofollow" className="px-3 py-1.5 rounded-full bg-white/10 text-white/80 text-xs hover:bg-white/20 hover:text-white transition-colors cursor-pointer whitespace-nowrap">Perfumes</a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/50 text-xs">
            &copy; {new Date().getFullYear()} Hipobuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-white/50 text-xs">
            A product research resource for smart shoppers.
          </p>
        </div>
      </div>
    </footer>
  );
}